import { MyDepartments } from '@features/departments';
import styles from './Departments.module.css';

export default function Departments(): React.ReactElement {
    return (
        <div className={styles.container}>
            <MyDepartments />
        </div>
    );
}
